<script setup lang="ts">
import type { Canvass, CanvassHouse } from "@/canvasses/types";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import EditLink from "@/components/links/EditLink.vue";
import ListItem from "@/components/ListItem.vue";
import ConversationDetails from "@/conversations/ConversationDetails.vue";
import { useGetConversations } from "@/conversations/conversationsCrud";
import { MultiBubble } from "@iconoir/vue";
import { RouterLink } from "vue-router";

const { canvassHouse } = defineProps<{
  canvass: Canvass; // suppress router warnings
  canvassHouse: CanvassHouse;
}>();

const { conversations, getConversationsStatus } = useGetConversations(
  canvassHouse.id,
);
</script>

<template>
  <div class="column container container-md">
    <div class="box">
      <h2 class="visually-hidden">Gespräche</h2>
      <RouterLink
        class="button"
        role="button"
        :to="{ name: 'canvassFlowNewConversation' }"
      >
        <MultiBubble />neues Gespräch
      </RouterLink>
    </div>
    <HandleQueryStatus :query-status="getConversationsStatus">
      <ul v-if="conversations && conversations.length > 0" role="list">
        <ListItem v-for="conversation in conversations" :key="conversation.id">
          <template #header>
            <h3>
              <RouterLink
                :to="{
                  name: 'canvassFlowEditConversation',
                  params: { conversationId: conversation.id },
                }"
              >
                Gespräch
              </RouterLink>
            </h3>
          </template>
          <ConversationDetails :conversation="conversation" />
          <template #actions>
            <EditLink
              :to="{
                name: 'canvassFlowEditConversation',
                params: { conversationId: conversation.id },
              }"
            />
          </template>
        </ListItem>
      </ul>
      <p v-else class="box">
        Für dieses Haus wurden noch keine Gespräche hinterlegt.
      </p>
    </HandleQueryStatus>
  </div>
</template>
